import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/user-slice";
import { UserState } from "./domain/models/User";
import { PromotionWorksState, WorksState } from "./domain/models/Work";
import worksSlice from "./slices/works-slice";
import { PlatformInfoState } from "./domain/models/PlatformInfo";
import platformInfoSlice from "./slices/platform-info-slice";
import { SubscriptionsState } from "./domain/models/Subscription";
import subscriptionsSlice from "./slices/subscriptions-slice";
import { NotificationsState } from "./domain/models/Notification";
import notificationsSlice from "./slices/notifications-slice";
import promotionWorksSlice from "./slices/promotion-works-slice";
import { ReviewsState } from "./domain/models/Review";
import reviewsSlice from "./slices/reviews-slice";
import { WorksStatisticState } from "./domain/models/WorksStatistic";
import worksStatisticSlice from "./slices/works-statistic-slice";

export interface AppState {
    user: UserState;
    works: WorksState;
    platformInfo: PlatformInfoState;
    subscriptions: SubscriptionsState;
    notifications: NotificationsState;
    promotionWorks: PromotionWorksState;
    reviews: ReviewsState;
    worksStatistic: WorksStatisticState;
}

export const store = configureStore({
    reducer: {
        user: userSlice,
        works: worksSlice,
        platformInfo: platformInfoSlice,
        subscriptions: subscriptionsSlice,
        notifications: notificationsSlice,
        promotionWorks: promotionWorksSlice,
        reviews: reviewsSlice,
        worksStatistic: worksStatisticSlice,
    },
});

export type AppDispatch = typeof store.dispatch;
